import { render, staticRenderFns } from "./RoleListView.vue?vue&type=template&id=2f1e257a&scoped=true"
import script from "./RoleListView.vue?vue&type=script&lang=js"
export * from "./RoleListView.vue?vue&type=script&lang=js"
import style0 from "./RoleListView.vue?vue&type=style&index=0&id=2f1e257a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1e257a",
  null
  
)

export default component.exports